import { render, staticRenderFns } from "./formTable.vue?vue&type=template&id=031a59ee&scoped=true"
import script from "./formTable.vue?vue&type=script&lang=js"
export * from "./formTable.vue?vue&type=script&lang=js"
import style0 from "./formTable.vue?vue&type=style&index=0&id=031a59ee&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031a59ee",
  null
  
)

export default component.exports